var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08967 6.50503L12.9848 0.385036C13.3503 0.133012 13.7304 0 14.0559 0C14.7704 0 15.2441 0.599463 15.2441 1.56413V14.4322C15.2441 14.9035 15.1071 15.2972 14.904 15.5713C14.6978 15.8491 14.3752 15.9961 14.0267 15.9961C13.7014 15.9961 13.3363 15.8628 12.9709 15.6112L4.08384 9.4912C3.51253 9.09735 3.19926 8.56725 3.19939 7.99786C3.19939 7.42873 3.51758 6.89863 4.08967 6.50503Z",
    fill: "#171717"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.857766 0L1.22546 0.00103713C1.70696 0.00103713 2.12378 0.393592 2.12378 0.87586V15.116C2.12378 15.5988 1.71383 15.9951 1.23169 15.9951L0.841078 16C0.361365 15.9974 1.81198e-05 15.5977 1.81198e-05 15.1168V0.874952C1.81198e-05 0.392685 0.375882 0 0.857766 0Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.7d9b820326a98a19665ec7999fb09799.svg";
export { ForwardRef as ReactComponent };